import { useCallback, useState } from 'react'
import { ActiveFilter } from '@sequencehq/core-components'
import { useIsOnSavedViewPage } from 'SavedViews/savedViews.router'

export function useSavedView() {
  const isSavedView = useIsOnSavedViewPage()

  const [savingFilters, setSavingFilters] = useState<false | ActiveFilter[]>(
    false
  )
  const [forceNewSavedView, setForceNewSavedView] = useState<boolean>(false)

  const onSaveFilters = useCallback(
    (activeFilters: ActiveFilter[]) => {
      if (isSavedView) {
        setForceNewSavedView(true)
      }

      setSavingFilters(activeFilters)
    },
    [isSavedView]
  )

  const onDismissSaveFilters = useCallback(() => {
    setForceNewSavedView(false)
    setSavingFilters(false)
  }, [])

  const showSavedViewEditor = savingFilters

  return {
    isSavedView,
    savingFilters,
    setSavingFilters,
    forceNewSavedView,
    onSaveFilters,
    onDismissSaveFilters,
    showSavedViewEditor
  }
}
